/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ApplicationNotification {
  id: string; // unique identifier for the notification, e.g., 'missing-income-block'
  message: string;
  type?: string; // e.g., 'dependency', 'validation'
  blockPublish?: boolean; // true if this should block publishing
  pageId?: string;
}

export interface ApplicationNotificationsState {
  notifications: ApplicationNotification[];
}

const initialState: ApplicationNotificationsState = {
  notifications: [],
};

const applicationNotificationsSlice = createSlice({
  name: 'applicationNotifications',
  initialState,
  reducers: {
    addApplicationNotification: (state, action: PayloadAction<ApplicationNotification>) => {
      if (!state.notifications.some((n) => n.id === action.payload.id)) {
        state.notifications.push(action.payload);
      }
    },
    removeApplicationNotification: (state, action: PayloadAction<string>) => {
      state.notifications = state.notifications.filter((n) => n.id !== action.payload);
    },
    clearApplicationNotifications: (state) => {
      state.notifications = [];
    },
    updateApplicationNotification: (state, action: PayloadAction<ApplicationNotification>) => {
      const idx = state.notifications.findIndex((n) => n.id === action.payload.id);
      if (idx !== -1) {
        state.notifications[idx] = action.payload;
      }
    },
  },
});

export const {
  addApplicationNotification,
  removeApplicationNotification,
  clearApplicationNotifications,
  updateApplicationNotification,
} = applicationNotificationsSlice.actions;
export default applicationNotificationsSlice.reducer;
